import React, { useState } from 'react';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Menu, useTheme } from '@mui/material';
import { useVigoTranslation } from 'src/@core/hooks/useVigoTranslation';

export interface IOrderBySelectReturn {
  orderByColumn: string;
  orderByIndex: number;
}

export interface IOrderBySelect {
  variant?: 'contained' | 'outlined' | 'text';
  onChange?: (data: IOrderBySelectReturn, event: React.MouseEvent<HTMLLIElement, MouseEvent>) => any;
  selectedValue?: string;
  hideDelete?: boolean;
}

const OrderBySelect = ({ variant, onChange, selectedValue = '0', hideDelete = false }: IOrderBySelect) => {
  const options = !hideDelete
    ? ['Delivery Date', 'Collection Date', 'Entered Date', 'Deleted Orders']
    : ['Delivery Date', 'Collection Date', 'Entered Date'];

  const [selectedIndex, setSelectedIndex] = useState(+selectedValue || 0);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const theme = useTheme();
  const open = Boolean(anchorEl);

  const { t } = useVigoTranslation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, index: number) => {
    let returnColumn = '';

    // calculate the date range based on selected values
    switch (index) {
      case 0: // Delivery Date
        returnColumn = 'deliveryDateTime';
        break;

      case 1: // Collection Date
        returnColumn = 'collectionDateTime';
        break;

      case 2: // Order Date
        returnColumn = 'orderDate';
        break;

      case 3: // Deleted
        returnColumn = 'deletedOn';
        break;

      default:
        returnColumn = '';
        break;
    }

    const returnData: IOrderBySelectReturn = {
      orderByColumn: returnColumn,
      orderByIndex: index
    };

    if (onChange) {
      onChange(returnData, event);
    }

    setSelectedIndex(index);
    handleClose();
  };

  return (
    <>
      <Button
        id="orderBySelectOptions-button"
        aria-controls={open ? 'orderBySelectOptions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{
          alignSelf: 'flex-end',
          color: theme.palette.mode === 'light' ? theme.palette.customColors.main : '#fff',
          textTransform: 'capitalize'
        }}
        variant={variant}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}>
        {t(options[selectedIndex])}
      </Button>
      <Menu
        id="orderBySelectOptions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'orderBySelectOptions-button'
        }}>
        {options.map((option, index) => (
          <MenuItem
            sx={{ alignSelf: 'flex-end', textTransform: 'capitalize' }}
            key={option}
            selected={index === selectedIndex}
            onClick={event => handleMenuItemClick(event, index)}>
            {t(option)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default OrderBySelect;
